import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Accusé de réception — enveloppe avec coche verte.
 * Différent de ViewIcon (œil = consulter) : sémantique "reçu et confirmé".
 */
export const AckIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille check menthe (en bas à droite) */}
      <circle cx="17.5" cy="17.5" r="4.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M15.5 17.5l1.5 1.5 3-3"
        stroke="hsl(var(--background))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Enveloppe */}
      <rect x="3" y="5.5" width="14" height="11" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path
        d="M3.5 6.5l6.5 5 6.5-5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
AckIcon.displayName = "AckIcon";
